export const getPropertyLabel = (propertyDefinitionMap, propertyName) => propertyDefinitionMap[propertyName] && propertyDefinitionMap[propertyName].label;